import { SettingsData } from "../../types/settings";
import { SET_LOGIN, SetLogin } from "../actions/authentication";

export const SET_SETTINGS = "SET_SETTINGS";
export const SET_QUIZ_NOW_QUIZZERS = "SET_QUIZ_NOW_QUIZZERS";

const getInitialState = () => {
  const previous: Partial<SettingsData> =
    JSON.parse(localStorage.getItem("settings") as string) || {};
  const state: SettingsData = {
    quizNowQuizzers: [""],
    qnBookName: false,
    qmSpeed: "MEDIUM",
    qmPrecise: false,

    myMaterial: [],
    selectedChapters: [],
    selectedSKBooks: [],
    versePresets: [],

    touchscreen: "ontouchstart" in window,
    lightMode: false,

    vcRandomize: "RANDOM",
    vcReview: true,
    vcVoiceToText: false,
    vcDisableAnimation: false,

    memReview: 3,
    memRefInput: "NONE",

    skAdvanced: false,
    skIncludeOvertime: true,
    skDisableGraphs: false,
    skCompact: false,
    skResultColors: false,

    ...previous,
  };

  // Old verse cards structure for backwards compatibility
  if (typeof state.vcRandomize === "boolean") {
    state.vcRandomize = state.vcRandomize ? "RANDOM" : "IN_ORDER";
  }

  return state;
};
const initialState = getInitialState();

const saveSettings = async (settings: SettingsData) => {
  localStorage.setItem("settings", JSON.stringify(settings));
};

export interface SetQuizNowQuizzers {
  type: "SET_QUIZ_NOW_QUIZZERS";
  payload: string[];
}
export interface SetSettings {
  type: "SET_SETTINGS";
  payload: SettingsData;
}
export type SettingsReducerTypes = SetQuizNowQuizzers | SetSettings | SetLogin;

export default function settings(
  state = initialState,
  action: SettingsReducerTypes
): SettingsData {
  let result = { ...state };
  switch (action.type) {
    case SET_QUIZ_NOW_QUIZZERS:
      result = {
        ...state,
        quizNowQuizzers: action.payload,
      };
      break;
    case SET_SETTINGS:
      result = action.payload;
      break;
    case SET_LOGIN:
      result = {
        ...state,
        ...action.payload.user?.preferences.settings,
      };
      break;
    default:
      result = state;
  }
  if (result !== initialState) saveSettings(result);
  return {
    ...state,
    ...result,
  };
}
